import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import registerPlatformAccessRoutes from './router/platformAccessRoutes'
import registerProjectNotificationRoutes from './router/projectNotificationRoutes'
import registerTenantAccessRoutes from './router/tenantAccessRoutes'
import registerNotFoundRoute from './router/notFoundRoute'
import legacyPdfDownloadMixin from './mixins/legacyPdfDownloadMixin'
import { publishProductNameToCss } from './common/productName'
import { ensureCsrfToken } from './services/csrf'
import { installCsrfRetry } from './services/csrfRetry'
import { installJapaneseOnlyMessages } from './services/japaneseOnlyMessages'
import CoreuiVue from '@coreui/vue'
import japaneseDataTable from './plugins/japaneseDataTable'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
// VeeValidateを追加
import { extend, ValidationProvider, ValidationObserver,setInteractionMode } from 'vee-validate';
import asTextRule from '@/utils/asTextRule'
import * as rules from 'vee-validate/dist/rules';
import { required, max, numeric } from "vee-validate/dist/rules";
import ja from 'vee-validate/dist/locale/ja'
import VModal from 'vue-js-modal'
import ConstList from './ConstList'
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
// 共通CSSのインポート
import './assets/common.css';

// ダイアログの設定
Vue.use(VuejsDialog);

Vue.config.devtools = true;
/*
 * CSS からも製品の名前を読めるようにする。**銘のいくつかは CSS の
 * content: で描かれていて、JS の定数を読めない。**呼び忘れると銘は空に
 * なるが、古い名前が出たままより良い（空はすぐ気づく）。
 */
publishProductNameToCss()

Vue.config.performance = true
Vue.use(CoreuiVue)
// 表が空のときの「No items」を日本語にする（CoreUI の登録より後で上書きする）
Vue.use(japaneseDataTable)
Vue.mixin(legacyPdfDownloadMixin)
// VeeValidateの設定
for (let rule in rules) {
  extend(rule, {
    ...rules[rule], // add the rule
    message: ja.messages[rule] // add its message（メッセージの日本語化）
  });
}
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
setInteractionMode('eager');

extend("required", {
  ...required,
  message: ConstList.REQUIRED
});

extend("numeric", {
  ...numeric,
  message: ConstList.NUMERIC
});

extend("max", {
  ...max,
  message: ConstList.MAX
});

// メールアドレスのカスタムルール
const email =  {
  message: ConstList.EMAIL_ERROR,
  validate(value) {
    if (value.match(ConstList.EMAIL_REGEX)) {
      return true
    }
  }
}
extend('email', asTextRule(email))

// 勤務表の時間のカスタムルール
const time = {
  message: ConstList.NUM_SYMBOL,
  validate(value) {
    if (value.match(ConstList.TIME_REGEX)) {
      return true
    }
  }
}
extend('time', asTextRule(time))

// 有給と代休のカスタムルール
const holiday = {
  message: ConstList.HOLIDAY_ERROR,
  validate(value) {
    if (value.match(ConstList.HOLIDAY_REGEX) || value.match(ConstList.DECIMAL_REGEX)) {
      return true
    }
  }
}
extend('holiday', asTextRule(holiday))

// 業務報告書の月日のカスタムルール
const date = {
  message: ConstList.NUM_SYMBOL,
  validate(value) {
    if (value.match(ConstList.DATE_REGEX)) {
      return true
    }
  }
}
extend('date', asTextRule(date))

// 業務報告書の基準時間のカスタムルール
const base_time = {
  message: ConstList.NUM_SYMBOL,
  validate(value) {
    if (value.match(ConstList.BASE_TIME_REGEX)) {
      return true
    }
  }
}
extend('base_time', asTextRule(base_time))

// 業務報告書の勤務時間時間時間時間等のカスタムルール
const total_time = {
  message: ConstList.NUM_SYMBOL,
  validate(value) {
    if (value.match(ConstList.WORK_TIME_REGEX)) {
      return true
    }
  }
}
extend('total_time', asTextRule(total_time))

// 社員番号のカスタムルール
const employee = {
  message: ConstList.EMPLOYEE_ERROR,
  validate(value) {
    if (value.match(ConstList.FULL_NUM_REGEX)) {
      return true
    }
  }
}
extend('employee', asTextRule(employee))

// 氏名のカスタムルール
const name = {
  params: ['num'],
  message: ConstList.FULL_WIDTH,
  validate(value, {num}) {
    if (value.length > num) {
      return false
    }
    if (value.match(ConstList.FULL_WIDTH_REGEX)) {
      return false
    }
    if (value.match(ConstList.HALF_KATAKANA_REGEX)) {
      return false
    }
    if (value.match(ConstList.USER_NAME_PATTEN_REGEX)) {
      return true
    }
  }
}
extend('name', asTextRule(name))

// 住所の文字種制限
const address = {
  message: ConstList.ADDRESS_ERROR,
  validate(value) {
    if (value.match(ConstList.HALF_KATAKANA_REGEX)) {
      return false
    }
    if (value.match(ConstList.FULL_WIDTH_REGEX)) {
      return false
    }
    return true
  }
}
extend('address', asTextRule(address))

// 電話番号のカスタムルール
const telephone = {
  message: ConstList.TELEPHONE_ERROR,
  validate(value) {
    if (value.length < 10 || value.length > 16) {
      return false
    }
    if(value.match(ConstList.TELEPHONE_REGEX)) {
      return true
    }
  }
}
extend('tel', asTextRule(telephone))

// 同値チェックのカスタムルール
const check = {
  params: [{
    name: 'str',
    isTarget: true
  }],
  message: ConstList.SAME,
  validate(value, {str}) {
    return value == str;
  }
};
extend('check', check);

// 新しく決めるパスワード。12〜64文字・文字の種類は問わない（決めたこと 15。招待と同じ規則）
const password = {
  message: ConstList.PASSWORD_ERROR,
  validate(value) {
    if (value.match(ConstList.PASSWORD_REGEX)) {
      return true
    }
  }
}
extend('password', asTextRule(password))

// 選択必須のカスタムルール
const select = {
  ...required,
  message: ConstList.SELECT
}
extend('select', select)

// 年月のカスタムルール
const month_year = {
  message: '{_field_}はYYYYMM形式で入力してください。',
  validate(value) {
    if (value.length == 6) {
      return true
    }else{
      return false
    }
  }
}
extend('month_year', asTextRule(month_year))

// 年月のカスタムルール
const month_math = {
  message: '{_field_}は半角数字で入力してください。',
  validate(value) {
    if (value.match(/\d/)) {
      return true
    }
  }
}
extend('month_math', asTextRule(month_math))

// 予定時間外申請の時間入力のカスタムルール(半角数字or小数点以下制限)
const half_width_and_limit_decimal = {
  message: ConstList.HALF_WIDTH_LIMIT_DECIMAL2_ERROR,
  validate(value) {
    if (value.match(ConstList.HALF_WIDTH_DECIMAL_REGEX2)) {
      return true
    }
  }
}
extend('half_width_and_limit_decimal', asTextRule(half_width_and_limit_decimal))

const hourMinute = {
  message: ConstList.HOUR_MINUTE_ERROR,
  validate(value) {
    if (!value.match(ConstList.TIME_REGEX)) {
      return false
    }

    // 時・分の範囲確認
    const [hours, minutes] = value.split(':').map(Number)

    return (
      hours >= 0 && hours <= 23 &&
      minutes >= 0 && minutes <= 59
    )
  }
}

extend('hourMinute', asTextRule(hourMinute))


// VModalの設定
Vue.use(VModal);

// 初回URLの解決より前に、権限管理画面と会社単位通知設定のルートを登録する。
// App.createdで追加すると、F5/直リンク時は初回ルート解決に間に合わず白紙になる。
registerPlatformAccessRoutes(router)
registerProjectNotificationRoutes(router)
registerTenantAccessRoutes(router)
// **いちばん最後。**`*` は何にでも当たるので、これより下に
// 経路の登録を足すと、その経路が丸ごと404に食われる。
registerNotFoundRoute(router)

/*
 * CSRF の合言葉。
 *
 * **取り付けは起動時に1回だけ。**画面ごとに付けると、同じ要求へ
 * 何重にもやり直しが掛かる。
 *
 * 取りに行くほうは待たない。待つと、通信が詰まっているときに
 * **画面が1枚も出ない**。実際に POST するときに断られ、そこで
 * 取り直す作りにしてある。
 */
installCsrfRetry()
// 英語だけの断りの文を画面へ出さない（2026-09-22）
installJapaneseOnlyMessages()
ensureCsrfToken()

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
